if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function(callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function() {

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
    paragraph.forEach(e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: false
    });

    if ($('a.fancybox')) {
        $('a.fancybox').fancybox();
    }

    $('.tr-gallery-left').slick({
        infinite: false,
        autoplay: false,
        autoplaySpeed: 7000,
        speed: 700,
        fade: true,
        asNavFor: '.tr-gallery-right'
    });

    $('.tr-gallery-right').slick({
        infinite: false,
        arrows: false,
        dots: false,
        autoplay: false,
        autoplaySpeed: 7000,
        speed: 700,
        fade: false,
        //slidesToShow: 2,
        //slidesToScroll: 2,
        variableWidth: true,
        asNavFor: '.tr-gallery-left'
    });

    $('.three-highlights__slider').slick({
        infinite: true,
        arrows: true,
        dots: false,
        autoplay: false,
        autoplaySpeed: 7000,
        speed: 700,
        fade: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [{
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    arrows: false,
                    dots: true
                }
            }
        ]
    });

    $('.two-highlights__slider').slick({
        infinite: true,
        arrows: true,
        dots: false,
        autoplay: false,
        autoplaySpeed: 7000,
        speed: 700,
        fade: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        responsive: [{
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    arrows: false,
                    dots: true
                }
            }
        ]
    });

    $('.accomodation-slides').slick({
        arrows: true,
        dots: false,
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 500,
        fade: true,
        accessibility: false
    });

    $('.gallery-two__slider').slick({
        arrows: true,
        dots: false,
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 700,
        fade: false,
        accessibility: false
    });


    $('.accommodations-shortcode__filter button').click(function() {
        $('.accomodation-slides').slick('unslick');
        const thisTag = $(this).attr('data-tag');
        if (thisTag == 'all') {
            $('.grid--filter .grid__col').hide();
            $('.grid--filter .grid__col').fadeIn();
            $('.grid--filter .grid__col .accomodation-slides').slick({
                arrows: true,
                dots: false,
                autoplay: true,
                autoplaySpeed: 5000,
                speed: 500,
                fade: true,
                accessibility: false
            });
            $('.accommodations-shortcode__filter button').removeClass('active');
            $(this).addClass('active');
            $(this).attr('aria-selected','true');
        } else {
            $('.grid--filter .grid__col').removeClass('active');
            $('.grid--filter .grid__col').hide();
            $('.grid--filter .' + thisTag).fadeIn();
            $('.grid--filter .' + thisTag + ' .accomodation-slides').slick({
                arrows: true,
                dots: false,
                autoplay: true,
                autoplaySpeed: 5000,
                speed: 500,
                fade: true,
                accessibility: false
            });
            $('.accommodations-shortcode__filter button').removeClass('active');
            $('.accommodations-shortcode__filter button').attr('aria-selected','false');
            $(this).addClass('active');
            $(this).attr('aria-selected','true');
        }
    })

    $('.attractions__filter .list button').click(function() {
        const thisTag = $(this).attr('data-tag');
        $('.attractions--filter .attractions__col').hide();
        $('.attractions--filter .' + thisTag).fadeIn(); 
        $('.attractions__filter .list button').removeClass('active');
        $(this).addClass('active');
    })

    if (document.querySelector('.attractions')) {
        const filter_tab = document.querySelectorAll('.attractions__filter .list button');
        filter_tab[1].click();
    }


    if (document.getElementById('open-terms')) {
        let btnTerms = document.getElementById('open-terms');
        let termsInfo = document.getElementById('terms-conditions');
        let termsInfoHeight = termsInfo.getElementsByTagName('p')[0].clientHeight;
        btnTerms.addEventListener('click', function(e) {
            e.preventDefault();
            termsInfo.classList.toggle('show');
            if (!this.classList.contains('up')) {
                this.classList.add('up');
                termsInfo.style.height = (termsInfoHeight + 20) + 'px';
            } else {
                this.classList.remove('up');
                termsInfo.style.height = '0px';
            }
        });
    }

    if (window.location.hash) {
        $('html,body').scrollTop(0);
        var hash = window.location.hash;
        var hashTop = $(hash).offset().top;
        $('html,body').animate({ scrollTop: hashTop - 250 }, 1000);
        console.log(hashTop);
    }

})();